<template>
  <div>
    <el-dialog
      title="新增請款單"
      :visible.sync="dialogTableVisible"
      width="30%"
    >
      <el-form :label-position="'top'" label-width="80px" :model="ruleForm">
        <el-form-item label="*主標題">
          <el-input v-model="invoiceInfo.title"></el-input>
        </el-form-item>
        <el-form-item label="*企業">
          <el-select
            v-model="index"
            placeholder="請選擇企業"
            @change="selectEnterpriceId()"
          >
            <el-option label="不選擇" :value="-1"></el-option>
            <!-- add key in el-option  -->
            <el-option
              v-for="(company, index) in companyList"
              :key="index"
              :value="index"
              :label="company.name"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="*月份">
          <el-date-picker
            v-model="invoiceInfo.requestDate"
            type="month"
            value-format="yyyy-MM"
            placeholder="選擇月份"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="*請款日">
          <el-date-picker
            v-model="invoiceInfo.requestOrderDate"
            type="date"
            value-format="yyyy-MM-dd"
            placeholder="選擇日期"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="*預估收款日">
          <el-date-picker
            v-model="invoiceInfo.estimatedReceiveDate"
            type="date"
            value-format="yyyy-MM-dd"
            placeholder="選擇日期"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="*預估司機領款日">
          <el-date-picker
            v-model="invoiceInfo.driverReceivePaymentDate"
            type="date"
            value-format="yyyy-MM-dd"
            placeholder="選擇日期"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="備註">
          <el-input v-model="invoiceInfo.invoiceNote"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="hideModal">取 消</el-button>
        <el-button type="primary" @click="createInvoice">新 增</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import EnterpriseAPI from '../../assets/js/libs/EnterpriseAPI'

export default {
  props: ['optSigningDetailList', 'companyList'],
  data() {
    return {
      index: -1,
      dialogTableVisible: false,
      invoiceInfo: {
        enterpriseId: 0,
        companyName: null,
        requestDate: null,
        invoiceNote: null,
        estimatedReceiveDate: null,
        title: null,
        driverReceivePaymentDate: null,
        requestOrderDate: null,
      },
      ruleForm: {
        name: '',
        region: '',
        date1: '',
        date2: '',
        delivery: false,
        type: [],
        resource: '',
        desc: '',
      },
      // rules: {
      //     name: [
      //       { required: true, message: '请输入活动名称', trigger: 'blur' },
      //       { min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur' }
      //     ],
      //     region: [
      //       { required: true, message: '请选择活动区域', trigger: 'change' }
      //     ],
      //     date1: [
      //       { type: 'date', required: true, message: '请选择日期', trigger: 'change' }
      //     ],
      //     date2: [
      //       { type: 'date', required: true, message: '请选择时间', trigger: 'change' }
      //     ],
      //     type: [
      //       { type: 'array', required: true, message: '请至少选择一个活动性质', trigger: 'change' }
      //     ],
      //     resource: [
      //       { required: true, message: '请选择活动资源', trigger: 'change' }
      //     ],
      //     desc: [
      //       { required: true, message: '请填写活动形式', trigger: 'blur' }
      //     ]
      //   }
    }
  },
  methods: {
    initialData() {
      this.index = -1
      this.invoiceInfo.enterpriseId = 0
      this.invoiceInfo.companyName = null
      this.invoiceInfo.requestDate = null
      this.invoiceInfo.invoiceNote = null
      this.invoiceInfo.estimatedReceiveDate = null
      this.invoiceInfo.title = null
      this.invoiceInfo.driverReceivePaymentDate = null
      this.invoiceInfo.requestOrderDate = null
    },
    selectEnterpriceId() {
      this.invoiceInfo.companyName = this.companyList[this.index].name
      this.invoiceInfo.enterpriseId = this.companyList[this.index].id
    },
    createInvoice() {
      if (this.invoiceInfo.companyName === null) return alert('輸入企業用戶')
      if (this.invoiceInfo.requestDate === null) return alert('輸入請款日期')
      if (this.invoiceInfo.estimatedReceiveDate === null)
        return alert('輸入預估收款日')
      if (this.invoiceInfo.driverReceivePaymentDate === null)
        return alert('輸入司機領款日')
      if (this.invoiceInfo.requestOrderDate === null)
        return alert('輸入請款時間')
      EnterpriseAPI.post('enterprise/invoice', this.invoiceInfo)
        .then((res) => {
          if (res.success) {
            alert('新增成功')
            this.hideModal()
            this.initialData
            this.$emit('updateInvoiceList', '')
          } else {
            alert('新增失敗')
          }
        })
        .catch((err) => {
          this.$msg('網路不穩定請在操作一次')
        })
    },
    hideModal() {
      this.initialData()
      this.dialogTableVisible = false
    },
    showModal() {
      this.dialogTableVisible = true
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/company/AddInvoiceModal.vue